import type { DrawerProps as ChakraDrawerProps } from '@chakra-ui/react';
import { Drawer as ChakraDrawer } from '@chakra-ui/react';
import React from 'react';

type DrawerSizeOption = 'sm' | 'md' | 'lg' | 'xl';
type DrawerPlacementOption = 'right' | 'left' | 'bottom';

export const drawerSizePropTypes: DrawerSizeOption[] = ['sm', 'md', 'lg', 'xl'];
export const drawerPlacementPropTypes: DrawerPlacementOption[] = ['right', 'left', 'bottom'];

export type DrawerProps = Omit<ChakraDrawerProps, 'size' | 'placement'> & {
  size?: DrawerSizeOption;
  placement?: DrawerPlacementOption;
};

const defaultProps = {
  size: 'md',
  placement: 'basic'
};

const Drawer = (props: DrawerProps): React.ReactElement => {
  return <ChakraDrawer {...props} />;
};

Drawer.defaultProps = defaultProps;

export default Drawer;
